module.exports = __webpack_public_path__ + "static/shotOnRedLogo-ab80e2b18ba9266bfa1a2031338561c6.png";